import React, { FC } from 'react'
import IconTextButton, { ButtonType } from 'components/buttons/TextIconButton'

import { t } from '@lingui/macro'
import { PlusIcon } from 'features/viewerPage/components/Chat/MessageInput/UploadButton/PlusIcon'
interface Props {
  onClick: () => void
}

export const CreateNewBannerButton: FC<Props> = ({ onClick }) => {
  return (
    <IconTextButton
      id="create-start-page-banner"
      type={ButtonType.Ghost}
      label={t`Create start page banner`}
      buttonSize="Medium"
      onClick={onClick}
    >
      <PlusIcon />
    </IconTextButton>
  )
}
